import { Link } from "react-router-dom";
import { Container } from "@/components/ui/Container";
import { Ornament } from "@/components/ui/Ornament";

export function NotFoundView() {
  return (
    <Container className="flex-1 flex flex-col items-center justify-center py-32 text-center">
      <p className="eyebrow text-accent">404 · No such page</p>
      <h1 className="display-title mt-3 text-[clamp(2.5rem,6vw,4rem)] leading-tight">
        We could not find that.
      </h1>
      <p className="mt-4 max-w-md text-muted">
        The link may be stale, or the event hasn't been created yet. Head back to the
        platform home.
      </p>
      <Ornament className="my-8" />
      <Link
        to="/"
        className="rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-canvas dark:bg-accent dark:text-accent-on hover:bg-ink/90 dark:hover:bg-accent/90 transition-colors"
      >
        Return home
      </Link>
    </Container>
  );
}

export default NotFoundView;
